export default function PageContact() {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Contact</h2>
      <p>De praktijk is telefonisch bereikbaar op het nummer <strong>015/31.19.59</strong>.
      <br />Onze secretaresse Stefanie is aanwezig
        <ul>
          <li>op maandag van 8u tot 12u30 en van 13u tot 16u30 en </li>
          <li>van dinsdag tot en met vrijdag van 8u tot 12u30.</li>
        </ul>
        </p>
      <p>Gelieve tussen 12u30 en 18u enkel te bellen voor dringende problemen die niet kunnen wachten tot de volgende voormiddag. 
        Na 18u en in het weekend, kan u steeds bellen naar 1733, het nummer van de huisarts van wacht / huisartsenwachtpost.</p>
      <div style={{ width: '100%' }}>
        <iframe 
          width="100%"
          height="600"
          style={{ border: 0 }}
          src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Grote%20Steenweg%2047,%202550%20Waarloos%20+(Artsenpraktijk%20Waarloos)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
          allowFullScreen
          loading="lazy">
        </iframe>
      </div>
    </div>
  );
}
